export default __webpack_public_path__ + "static/media/akbank.52c23515.png";